export const initialState = {
  affiliations: []
}

export default function(state=initialState, action) {
  const { type } = action
  const payload = action.payload || {}

  switch(type) {
    case 'AFFILIATIONS_LOAD_SUCCEEDED':
      return {
        ...state,
        affiliations: payload.data
      }
    default:
      return state
  }
}
